var getSlideTranslate = function getSlideTranslate(_ref) {
  var visualOffset = _ref.visualOffset,
    alignment = _ref.alignment,
    visibleSlidesCount = _ref.visibleSlidesCount,
    extraPixels = _ref.extraPixels;
  var relativeX = 100 * -visualOffset;
  if (alignment === 'left' || extraPixels === 0 || visibleSlidesCount === 0) {
    return "".concat(relativeX, "%");
  }

  // Extra space is added to right align slides at the end of navigation
  if (alignment === 'right') {
    return "calc(".concat(relativeX, "% + ").concat(extraPixels, "px)");
  }

  // Extra space is devided by two to center slides while navigation is somewhere
  // in the middle
  if (alignment === 'center') {
    return "calc(".concat(relativeX, "% + ").concat(extraPixels / 2, "px)");
  }
  throw new Error('Alignment should be set to left, center, or right');
};
export default getSlideTranslate;